import { render, staticRenderFns } from "./ValueClassView.vue?vue&type=template&id=a87ce9e4&"
import script from "./ValueClassView.vue?vue&type=script&lang=js&"
export * from "./ValueClassView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports